import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { OrderSliceState } from "../BCSOrder/BCSOrderSlice";
import { AddOrderFormValues } from "../../Interfaces/callOptionsInterfaces";

const initialState: OrderSliceState = {
  addOrderFormValues: null,
  orderTableFetchDataFlag: false,
  tradeTableFetchDataFlag: false,
};

const ReplacementCoveredOrderSlice = createSlice({
  name: "replacementCoveredOrder",
  initialState,
  reducers: {
    setAddReplacementCoveredOrderFormValues: (
      store,
      action: PayloadAction<AddOrderFormValues>
    ) => {
      if (store.addOrderFormValues !== action.payload)
        store.addOrderFormValues = action.payload;
    },
    setReplacementCoveredOrderTableFetchDataFlag: (
      store,
      action: PayloadAction<boolean>
    ) => {
      if (store.orderTableFetchDataFlag !== action.payload)
        store.orderTableFetchDataFlag = action.payload;
    },
    setReplacementCoveredTradeTableFetchDataFlag: (
      store,
      action: PayloadAction<boolean>
    ) => {
      if (store.tradeTableFetchDataFlag !== action.payload)
        store.tradeTableFetchDataFlag = action.payload;
    },
  },
});

export const {
  setAddReplacementCoveredOrderFormValues,
  setReplacementCoveredOrderTableFetchDataFlag,
  setReplacementCoveredTradeTableFetchDataFlag,
} = ReplacementCoveredOrderSlice.actions;
export default ReplacementCoveredOrderSlice.reducer;
